export interface IShaButtonGroupProps {
  title: string;
}
